<div class="main-content">
  <div class="container-fluid">
    <!--<div
      *ngIf="
        this.privilegio.level == 'ADMINISTRATOR' ||
        this.privilegio.level == 'worker' ||
        this.privilegio.level == 'PURCHASINGREP' ||
        this.privilegio.level == 'MANAGER'
      "
      style="float: right; margin-right: 20px"
      class="row"
    >
      <button
        (click)="openNuevoFolder()"
        mat-raised-button
        class="btn btn-success"
      >
        <span class="btn-label">
          <i class="material-icons">create_new_folder</i>
        </span>
        New Folder
      </button>
    </div>-->
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card/-header-primary card-header-icon">
            <div class="card-icon">
              <i class="material-icons">assignment</i>
            </div>
            <h4 class="card-title">Companies</h4>
          </div>
          <div class="card-body">
            <div id="posearch">

              <div *ngIf="loading" class="row" style="text-align: center">
                <div class="col-12">
                  <h2>
                    <b
                      ><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                      Loading...</b
                    >
                  </h2>
                </div>
              </div>
              <!-- inicia PO Search -->
              <!--<a
                (click)="showposrch()"
                style="color: green; font-weight: 500; cursor: pointer"
              >
                <i class="material-icons">search</i>
                PO Search
              </a>-->
              <div *ngIf="this.showposearch == 1" id="container-po-search">
                <form>
                  <input
                    type="text"
                    placeholder="Search PO"
                    class="form-control"
                    [(ngModel)]="this.advancedpotext"
                    name="advancedpotext"
                  />
                  <button class="btn btn-info" (click)="searchPO()">
                    Search
                  </button>
                </form>
              </div>

              <div
                id="showMsgPOSearching"
                style="display: none"
                class="alert alert-info"
                role="alert"
              >
                <i style="color: white" class="material-icons"> sync </i> Please
                wait, searching in progress
              </div>

              <div
                *ngIf="this.showMsgPOSearchingNotResults == 1"
                id="showMsgPOSearchingNotResults"
                class="alert alert-danger"
                role="alert"
              >
                <i style="color: white" class="material-icons"> cancel </i> No
                records found, please try again
              </div>

              <div
                *ngIf="this.showsearchPOResults == 1"
                class="material-datatables"
              >
                <table
                  id="datatablesPOSearch"
                  class="table table-striped table-no-bordered table-hover"
                  cellspacing="0"
                  width="100%"
                  style="width: 100%"
                >
                  <thead>
                    <tr>
                      <th>{{ dataTablePOSearch.headerRow[0] }}</th>
                      <th class="disabled-sorting text-right">
                        {{ dataTablePOSearch.headerRow[1] }}
                      </th>
                    </tr>
                  </thead>
                  <tfoot>
                    <tr>
                      <th>{{ dataTablePOSearch.footerRow[1] }}</th>
                      <th class="text-right">
                        {{ dataTablePOSearch.footerRow[1] }}
                      </th>
                    </tr>
                  </tfoot>
                  <tbody>
                    <tr
                      *ngFor="let row of dataTablePOSearch.dataRows"
                      id="file{{ row[0] }}"
                    >
                      <td>{{ row[1] }}</td>
                      <td class="text-right">
                        <a (click)="goFolder(row[0])"
                          ><button mat-raised-button class="btn btn-info">
                            Open Folder
                          </button></a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- end PO Search -->
            <!--<div class="toolbar" style="text-align: right;">
              <button type="button" class="btn btn-outline-info"
                [routerLink]="['/archive']" routerLinkActive="router-link-active"
              > <i class="fa fa-eye" aria-hidden="true"></i> &nbsp; My archived folders</button>
            </div>-->

            <dinamic-table
              *ngIf="!loading"
              [id]="'foldersTable'"
              [data]="data"
              [columnfilters]="filtros"
              [campoBusqueda]="campoBusqueda"
              [dateColums]="[4]"
              [perPage]="itemsPorPagina"
              [page]="paginaActual"
              [total_items_count]="totalItems"
              [total_pages]="totalPaginas"
              [config]="options"
              (buscar)="getAllPacientes($event,false)"
              [bulk]="bulk"
              (action_button)="action($event)"
            ></dinamic-table>


          </div>
          <!-- end content-->
        </div>
        <!--  end card  -->
      </div>
      <!-- end col-md-12 -->
    </div>
    <!-- end row -->
  </div>
</div>
